import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L, ModuleFE_WindowMessenger, Button } from '@nu-art/thunderstorm-frontend/index';
import * as React from 'react';
import './Page_SandboxFrame.scss';
const iframeSource = `${window.location.origin}/sandbox/orders`;
export class Page_SandboxFrame extends ComponentSync {
    iframeRef = React.createRef();
    static Route = {
        key: 'frame',
        path: 'frame',
        Component: this,
    };
    messenger_orderBlackBox = () => {
        if (!this.iframeRef.current)
            return;
        return ModuleFE_WindowMessenger.createMessenger(this.iframeRef.current.contentWindow);
    };
    answerHandshake = () => {
        const saferContent = `{'sup': 'yo', 'token': 'got the token'}`.replace(/'/g, '"');
        const message = JSON.parse(saferContent);
        this.messenger_orderBlackBox()?.sendMessage(message);
    };
    render() {
        return _jsxs(LL_V_L, { className: 'sandbox-frame', children: [_jsxs(LL_H_C, { className: 'buttons-container', children: [_jsx(Button, { onClick: this.answerHandshake, children: "Send message A" }), _jsx(Button, { children: "Send message B" })] }), _jsx("iframe", { className: 'i-frame', src: iframeSource, ref: this.iframeRef })] });
    }
}
//# sourceMappingURL=Page_SandboxFrame.js.map